import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../firebase-client';

const createUserNotificationFn = httpsCallable(functions, 'createUserNotification');

export async function createNotification({
  userId,
  message,
  actionUrl = '',
  type = '',
  teamId = '',
  familyId = '',
  pushCategory = '',
  pushUrgency = '',
  pushTitle = '',
  pushBody = '',
  pushContext = '',
  pushPreview = '',
  pushTimestamp = null,
  dedupeKey = '',
  notificationCategory = '',
}) {
  if (!userId || !message) {
    throw new Error('userId and message are required.');
  }

  const currentUid = auth.currentUser?.uid || null;
  if (!teamId && !familyId && currentUid && currentUid !== userId) {
    throw new Error('Cross-user notifications require a scope.');
  }

  await createUserNotificationFn({
    userId,
    message,
    actionUrl,
    type,
    teamId,
    familyId,
    pushCategory,
    pushUrgency,
    pushTitle,
    pushBody,
    pushContext,
    pushPreview,
    pushTimestamp,
    dedupeKey,
    notificationCategory,
  });
}
